import React from 'react';
import classNames from 'classnames';
import './styles.scss';
import Tooltip from '../Tooltip';

const ProgressBar = ({ percent, className, variant, tooltip }) => {
  const newClassName = classNames('progress', className, variant); 

  return (
      <div className={newClassName}>
        <div className="progress-bar" style={{ width: `${percent}%` }}></div>
        {tooltip && <Tooltip show className={'progressBar'} style={{left: `${percent}%`}}>{tooltip}</Tooltip>}
      </div>
  );
};

export default ProgressBar;
